import {CryptoHolding} from '@/integrations/supabase/crypto.models.ts';
import {computeCryptoHoldingsAggregation} from "@cryptoUtils";

/**
 * Pure selector: groups holdings by symbol and computes aggregated totals.
 * No React hooks — safe to call inside useMemo or in plain utility code.
 */
export function useCryptoHoldingsAggregation(holdings: CryptoHolding[]): AggregatedCryptoHolding[] {
    return computeCryptoHoldingsAggregation(holdings);
}
